import React from 'react';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './PricingSection';
export function FinalCtaSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-65">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-blue-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-66" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-67">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-68">
          El próximo lunes puede ser diferente.
        </h2>

        <p className="text-xl md:text-2xl text-blue-300 font-medium italic mb-12 max-w-3xl mx-auto" data-id="element-69">
          "El cambio más importante en una relación no es el que se ve. Es el
          que se construye adentro, un acuerdo a la vez." 💑
        </p>

        <div className="mb-12" data-id="element-70">
          <p className="text-red-400 font-bold mb-4" data-id="element-71">⏰ EL PRECIO CIERRA EN:</p>
          <CountdownTimer data-id="element-72" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12" data-id="element-73">
          {/* Standard Pack CTA */}
          <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 flex flex-col justify-between" data-id="element-74">
            <div data-id="element-75">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-76">
                💑 MEGAPACK MATRIMONIO SIN CRISIS
              </h3>
              <p className="text-sm text-slate-400 mb-4" data-id="element-77">
                6 Tomos + 6 Bonos · Para cualquier etapa
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-78">
                <span className="text-lg text-slate-500 line-through" data-id="element-79">$49</span>
                <span className="text-3xl font-bold text-white" data-id="element-80">$9.99</span>
              </div>
            </div>
            <button onClick={() => window.open('https://recursopack.com/cart/40978179719217:1', '_blank')} className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 px-4 rounded-xl transition-colors text-center cursor-pointer" data-id="element-81">
              → QUIERO MI MEGAPACK
            </button>
            <p className="text-[10px] text-slate-500 text-center mt-2" data-id="element-82">
              🌎 Pagalo en tu moneda local
            </p>
          </div>

          {/* Master Pack CTA */}
          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-gold-500 rounded-2xl p-6 flex flex-col justify-between shadow-[0_0_30px_rgba(234,179,8,0.1)]" data-id="element-83">
            <div data-id="element-84">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-85">
                🏆 MEGAPACK + BLINDAJE ANTICRISIS ⭐
              </h3>
              <p className="text-sm text-gold-400 mb-4" data-id="element-86">
                6 Tomos + 6 Bonos + Sistema de Protección Total
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-87">
                <span className="text-lg text-slate-500 line-through" data-id="element-88">$69</span>
                <span className="text-3xl font-bold text-white" data-id="element-89">$14.99</span>
              </div>
            </div>
            <button onClick={() => window.open('https://recursopack.com/cart/40978180210737:1', '_blank')} className="w-full bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-400 hover:to-yellow-300 text-navy-900 font-bold py-3 px-4 rounded-xl transition-all transform hover:scale-105 text-center cursor-pointer" data-id="element-90">
              → QUIERO EL MEGAPACK COMPLETO
            </button>
            <p className="text-[10px] text-slate-500 text-center mt-2" data-id="element-91">
              🌎 Pagalo en tu moneda local
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400" data-id="element-92">
          <span className="flex items-center gap-2" data-id="element-93">
            <Lock className="w-4 h-4" data-id="element-94" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-95">
            <Shield className="w-4 h-4" data-id="element-96" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-97">
            <CreditCard className="w-4 h-4" data-id="element-98" /> Pagalo en tu moneda local
          </span>
        </div>
      </div>
    </section>;
}